/*
* @Author: gujianghua
* @Date:   2019-11-18 17:15:28
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-11-02 18:28:04
*/
import { service,BASE_API } from '@/utils/request'
const v2 = BASE_API
const staticUrl = process.env.BASE_STATIC

export default {
	getList(data) {
		return service ({
		  url: '/cloud/activity/coupon/list',
		  method: 'get',
		  params: data
		})
	},
	addData(data) {
		return service ({
		  url: '/cloud/activity/coupon/add',
		  method: 'post',
		  data: data
		})
	},
	getDetail(data) {
		return service ({
		  url: '/cloud/activity/coupon/detail',
		  method: 'get',
		  params: data
		})		
	},
	editData(data) {
		return service ({
		  url: '/cloud/activity/coupon/update',
		  method: 'post',
		  data: data
		})		
	},
	getUsers(data) {
		return service ({
		  url: '/cloud/activity/coupon/users',
		  method: 'get',
		  params: data
		})		
	},	
	//获取列表
  	getCourseTypeList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/list',
	      method: 'get',
	      params: data
	    })
	},
	//生成短连接
	getShorturl(data) {
	  return service({
	    url: '/cloud/bbs/v1/app/config/shortURL',
	    method: 'post',
	    data: data
	  })
	},
	excelUpload: v2 + '/cloud/activity/coupon/grantExcel',
	// 下载模板
	down: staticUrl + '/document/sendCoupon.xls',
}


// WEBPACK FOOTER //
// ./src/api/operateManage/couponManage.js